export const url = {
  CDN_URL: 'https://web-shop-assets.s3.eu-central-1.amazonaws.com',
  redirectLogin: (returnUrl: string) => `${import.meta.env.VITE_REDIRECT_URL}${returnUrl}`,
  redirectDashboard: `${import.meta.env.VITE_FABLEBORNE_URL}/dashboard`,
  redirectToOrderHistory: `${import.meta.env.VITE_FABLEBORNE_URL}/order-history`,
  appleStoreUrl: 'https://apps.apple.com/us/app/fableborne/id1623855674',
  googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.PixionGames.Fableborne',
};
